export default __webpack_public_path__ + "static/media/logo.683aa882.svg";